import { useContext } from 'react';

import { CurrentUserContext } from '../contexts/CurrentUserContext';

const useUser = () => {
  const currentUser = useContext(CurrentUserContext);
  if (!currentUser) {
    throw new Error('useUser must be used within a CurrentUserProvider');
  }

  return currentUser;
};

export default useUser;
